<template>
    <div>
        <div class="wrapper-full-page section content">
            <div class="" v-if="this.$store.state.permit.RulesUser.roles.includes('staff')">
                <div class="col-md-10 offset-md-1">
                    <div class="mt-4 mb-3">
                        <h3 style="font-weight:100" class="font-en">
                            <strong class="font-en font-weight-bold"><span class="text-pur">MUIC</span> E-mail anouncment</strong>
                        </h3>
                    </div>
                    <b-tabs card>
                        <b-tab active>
                            <template #title><h5 class="mt-0 mb-0 font-thai"><i class="fa fa-cogs mr-2" aria-hidden="true" />ตั้งค่าข้อความ</h5></template>
                            <b-tabs active-nav-item-class="font-weight-bold h5 text-white bg-info" vertical>
                                <b-tab @click="getSubjectmail" active>
                                    <template #title><h6 class="mt-0 mb-0 font-thai"><i class="fa fa-list mr-1" aria-hidden="true" />รายการข้อความ</h6></template>
                                    <b-card-text>
                                        <div v-if="isBusymsg">
                                            <b-spinner class="mt-0" small></b-spinner>
                                            <span class="ml-2 font-weight-bold font-en">Load massage...</span>
                                        </div>
                                        <div v-else>
                                            <div v-if="itemsmsgHistory.length != 0">
                                                <b-card v-for="(item, index) in itemsmsgHistory" :key="'A'+ index" no-body class="mb-1">
                                                    <b-link class="text-dark ml-3 mt-3 mb-3" block>
                                                        <!-- 1 -->
                                                        <div v-if="item.id === viewIdItem && viewCase === 'topic'">
                                                            <label class="font-en mt-2 mb-1 text-dark font-weight-bold">Toppic :</label>
                                                            <b-input-group>
                                                                <b-form-input v-model="valEdit" type="text" class="font-en"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button @click="saveEdit(item.id,'topic')" size="sm" variant="success" class="text-capitalize">Update</b-button>
                                                                    <b-button @click="cancelView" size="sm" variant="danger" class="text-capitalize"><i class="fa fa-times" aria-hidden="true" /></b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </div>
                                                        <div v-else>
                                                            <p class="mt-2 mb-0 font-en font-toppic">
                                                                Toppic :<strong class="ml-2">{{ item.topic }}</strong>
                                                                <b-badge @click="formEdit(item.topic,item.id,'topic')" class="align-top text-info" variant="link"><i class="fa fa-pencil" aria-hidden="true" /></b-badge>
                                                            </p>
                                                        </div>
                                                        <!-- 2 -->
                                                        <div v-if="item.id === viewIdItem && viewCase === 'from_email'">
                                                            <label class="font-en mt-2 mb-1 text-dark font-weight-bold">Form :</label>
                                                            <b-input-group>
                                                                <b-form-input v-model="valEdit" type="text" class="font-en"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button @click="saveEdit(item.id,'from_email')" size="sm" variant="success" class="text-capitalize">Update</b-button>
                                                                    <b-button @click="cancelView" size="sm" variant="danger" class="text-capitalize"><i class="fa fa-times" aria-hidden="true" /></b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </div>
                                                        <div v-else>
                                                            <p class="mt-2 mb-0 font-en">
                                                                Form :<strong class="ml-2">{{ item.from_email }}</strong>
                                                                <b-badge @click="formEdit(item.from_email,item.id,'from_email')" class="align-top text-info" variant="link"><i class="fa fa-pencil fa-lg" aria-hidden="true" /></b-badge>
                                                            </p>
                                                        </div>
                                                        <!-- 3 -->
                                                        <div v-if="item.id === viewIdItem && viewCase === 'reply_to_email'">
                                                            <label class="font-en mt-2 mb-1 text-dark font-weight-bold">Reply :</label>
                                                            <b-input-group>
                                                                <b-form-input v-model="valEdit" type="text" class="font-en"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button @click="saveEdit(item.id,'reply_to_email')" size="sm" variant="success" class="text-capitalize"><i class="fa fa-check" aria-hidden="true" /></b-button>
                                                                    <b-button @click="cancelView" size="sm" variant="danger" class="text-capitalize"><i class="fa fa-times" aria-hidden="true" /></b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </div>
                                                        <div v-else>
                                                            <p class="mt-2 mb-0 font-en">
                                                                Reply :<strong class="ml-2">{{ item.reply_to_email }}</strong>
                                                                <b-badge @click="formEdit(item.reply_to_email,item.id,'reply_to_email')" class="align-top text-info" variant="link"><i class="fa fa-pencil fa-lg" aria-hidden="true" /></b-badge>
                                                            </p>
                                                        </div>
                                                        <!-- 4 -->
                                                        <div v-if="item.id === viewIdItem && viewCase === 'bcc_email'">
                                                            <label class="font-en mt-2 mb-1 text-dark font-weight-bold">Reply :</label>
                                                            <b-input-group>
                                                                <b-form-input v-model="valEdit" type="text" class="font-en"></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button @click="saveEdit(item.id,'bcc_email')" size="sm" variant="success" class="text-capitalize"><i class="fa fa-check" aria-hidden="true" /></b-button>
                                                                    <b-button @click="cancelView" size="sm" variant="danger" class="text-capitalize"><i class="fa fa-times" aria-hidden="true" /></b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </div>
                                                        <div v-else>
                                                            <p class="mt-2 mb-0 font-en">
                                                                BCC :<strong class="ml-2">{{ item.bcc_email !== '' && item.bcc_email !== null ? item.bcc_email : '-' }}</strong>
                                                                <b-badge @click="formEdit(item.bcc_email,item.id,'bcc_email')" class="align-top text-info" variant="link"><i class="fa fa-pencil fa-lg" aria-hidden="true" /></b-badge>
                                                            </p>
                                                        </div>
                                                        <p class="mt-2 mb-0 font-en text-muted ">Updated at : {{ moment(item.updated_at).format('LLLL') }}</p>
                                                        <b-button-group size="sm" class="mt-2 mb-1">
                                                            <b-button v-b-toggle="`msg-${item.id}`" class="text-lowercase" variant="info">More detail massage</b-button>
                                                            <b-button @click="delmsg(item.id)" class="text-lowercase" variant="danger"><i class="fa fa-trash" aria-hidden="true"/></b-button>
                                                        </b-button-group>
                                                    </b-link>
                                                    <b-collapse :id="`msg-${item.id}`" accordion="my-msg" role="tabpanel">
                                                        <div v-if="item.id === viewIdItem && viewCase === 'html_content'">
                                                            <div class="mr-3 ml-3 mb-4">
                                                                <yimo-vue-editor class="font-thai mt-2 mb-2" v-model="valEdit" :config="editorConfig"/>
                                                                <div class="text-right mt-3 mb-3">
                                                                    <b-input-group>
                                                                        <b-input-group-append>
                                                                            <b-button @click="saveEdit(item.id,'html_content')" size="sm" variant="success" class="text-capitalize"><i class="fa fa-check" aria-hidden="true" /></b-button>
                                                                            <b-button @click="cancelViewContent" size="sm" variant="danger" class="text-capitalize"><i class="fa fa-times" aria-hidden="true" /></b-button>
                                                                        </b-input-group-append>
                                                                    </b-input-group>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div class="text-right">
                                                                <b-badge @click="formEdit(item.html_content,item.id,'html_content')" class="align-top text-info" variant="link"><i class="fa fa-pencil fa-lg" aria-hidden="true" /></b-badge>
                                                            </div>
                                                            <b-alert show variant="dark-cus" class="ml-3 mr-3 mt-2 mb-4">
                                                                <span class="font-en text-dark" v-html="item.html_content"></span>
                                                            </b-alert>
                                                        </div>
                                                    </b-collapse>
                                                </b-card>
                                            </div>
                                            <div v-else>
                                                <p class="mt-2 mb-0 font-en font-toppic"><strong class="text-danger">Not found massage.</strong></p>
                                            </div>
                                        </div>
                                    </b-card-text>
                                </b-tab>
                                <b-tab>
                                    <template #title><h6 class="mt-0 mb-0 font-thai"><i class="fa fa-pencil-square-o mr-1" aria-hidden="true" />เพิ่มข้อความ</h6></template>
                                    <b-card-text>
                                        <p class="font-thai mt-1 mb-2 text-dark">Toppic<span class="ml-2 text-danger">*</span></p>
                                        <b-form-input class="font-thai" v-model="formDataMail.subject" placeholder=""></b-form-input>
                                        <p class="font-thai mt-3 mb-2 text-dark">From<span class="ml-2 text-danger">*</span></p>
                                        <b-form-input class="font-thai" v-model="formDataMail.from_email" placeholder=""></b-form-input>
                                        <p class="font-thai mt-3 mb-2 text-dark">Reply<span class="ml-2 text-danger">*</span></p>
                                        <b-form-input class="font-thai" v-model="formDataMail.reply_to_email" placeholder=""></b-form-input>
                                        <p class="font-thai mt-3 mb-1 text-dark">(สำเนา) BCC E-mail<span class="ml-2 text-danger">*</span></p>
                                        <small class="font-thai mt-1 mb-3 text-muted">กด Enter 1 ครั้ง / การพิมพ์</small>
                                        <input-tag class="mt-2 font-thai" v-model="formDataMail.bcc_email"></input-tag>
                                        <!-- editor -->
                                        <p class="font-thai mt-3 mb-3 text-dark">เนื้อความ<span class="ml-2 text-danger">*</span></p>
                                        <div class="">
                                            <yimo-vue-editor class="font-thai mt-2 mb-2" v-model="formDataMail.content" :config="editorConfig"/>
                                        </div>
                                        <b-button :disabled="!isFormMail" @click="submitContent" class="font-thai font-2x mt-3 mb-5" variant="success" block>
                                            <i class="fa fa-save mr-2" aria-hidden="true" />บันทึก
                                        </b-button>
                                    </b-card-text>
                                </b-tab>
                            </b-tabs>
                        </b-tab>
                        <b-tab @click="getSubjectmail">
                            <template #title><h5 class="mt-0 mb-0 font-thai"><i class="fa fa-paper-plane-o mr-2" aria-hidden="true"/>ส่งข้อความ</h5></template>
                            <b-card-text>
                                <div class="row">
                                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                        <h5 class="font-thai mt-3 mb-3 text-dark">1. เลือกข้อความที่ต้องการส่ง</h5>
                                        <b-form-select class="font-thai" v-model="selectedSubject" :options="optionsSubject"></b-form-select>
                                        <!-- test btn -->
                                        <div class="text-right">
                                            <b-button :disabled="selectedSubject === null" @click="modalTest" class="font-thai mt-2 mb-3" size="sm" variant="info">
                                                <i class="fa fa-info mr-1" aria-hidden="true" />ทดสอบส่งเมลล์
                                            </b-button>
                                        </div>
                                        <div class="w-100 mt-5 mb-3 d-flex justify-content-between">
                                            <div>
                                                <h5 class="font-thai text-dark">2. เลือกข้อมูลผู้รับแจ้งเตือน</h5>
                                            </div>
                                        </div>
                                        <div class="mt-2 mb-5">
                                            <b-button-group class="btn-sm font-thai font-weight-bold" size="sm">
                                                <b-button :pressed="checPressBtn === '1'" @click="getViewSend('1')" variant="outline-primary">แบบชั้นปี</b-button>
                                                <b-button :pressed="checPressBtn === '2'" @click="getViewSend('2')" variant="outline-primary">ระบุช่วงรหัส</b-button>
                                                <b-button :pressed="checPressBtn === '3'" @click="getViewSend('3')" variant="outline-primary">อัพโหลดไฟล์</b-button>
                                            </b-button-group>
                                        </div>
                                        <div v-if="checPressBtn === '1'">
                                            <b-form-group>
                                                <b-form-radio-group
                                                    id="checkbox-group-1"
                                                    size="lg"
                                                    v-model="selectedStdYearRadio"
                                                    name="flavour-1"
                                                    stacked
                                                >
                                                    <div class="row">
                                                        <div v-for="(itemOp, op) in optionsStdYear" :key="'choice'+ op" class="col-md-6">
                                                            <b-form-radio :value="itemOp.value" @change="getValData($event,itemOp.value)">
                                                                <p class="font-weight-bold font-en mt-0 mb-0">{{ itemOp.text }}</p>
                                                                <p class="font-en f-small-choice mt-0 mb-2 text-muted">นศ. จำนวน : {{ itemOp.amount_users }} คน</p>
                                                            </b-form-radio>
                                                        </div>
                                                    </div>
                                                </b-form-radio-group>
                                            </b-form-group>
                                        </div>
                                        <div v-if="checPressBtn === '2'" class="text-center">
                                            <b-form inline class="text-center">
                                                <b-input-group prepend="เริ่ม" class="mb-2 mr-sm-2 mb-sm-0">
                                                    <b-form-input maxlength="7" v-model="minInput" id="inline-form-input-username" placeholder="6280xxxx"></b-form-input>
                                                </b-input-group>
                                                <b-input-group prepend="ถึง" class="mb-2 mr-sm-2 mb-sm-0">
                                                    <b-form-input maxlength="7" v-model="maxInput" id="inline-form-input-username" placeholder="6280xxxx"></b-form-input>
                                                </b-input-group>
                                            </b-form>
                                            <div class="text-center">
                                                <b-button :disabled="['',null].includes(minInput) || ['',null].includes(maxInput)" @click="getValDataInput" small class="font-thai btn-sm font-weight-bold mt-3 mb-2 text-white" variant="info"><strong style="font-size: 14px;"  class="text-white">เรียกข้อมูล</strong></b-button>
                                            </div>
                                        </div>
                                        <div v-if="checPressBtn === '3'">
                                            <h6 class="thai-font mt-0 mb-2">
                                                Choose Excel file<span class="text-danger ml-2">*</span>
                                            </h6>
                                            <b-form-file v-model="file" @change="onFileChange"></b-form-file>
                                            <b-button @click="clearFile" block size="sm" class="font-thai mt-4 mb-3 font-weight-bold" variant="danger">Clear File</b-button>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">

                                        <b-card class="font-thai font-weight-bold" title="ข้อมูลอีเมลล์" sub-title="">
                                            <b-card-text>

                                                <!-- {{ selectedCaseSend }} -->
                                                <div class="mt-3 mb-3 row">
                                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        <b-form-group label="ประเภท เมลล์ที่ต้องการส่ง :" v-slot="{ ariaDescribedby }">
                                                            <b-form-checkbox-group
                                                                id="checkbox-group-2"
                                                                v-model="selectedCaseSend"
                                                                :aria-describedby="ariaDescribedby"
                                                                name="flavour-2"
                                                            >
                                                                <b-form-checkbox class="text-dark" value="edu"><strong class="text-dark font-weight-bold">@mahidol.edu</strong></b-form-checkbox>
                                                                <b-form-checkbox class="text-dark" value="acth"><strong class="text-dark font-weight-bold">@mahidol.ac.th</strong></b-form-checkbox>
                                                            </b-form-checkbox-group>
                                                        </b-form-group>
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        <!-- btn controll -->
                                                        <div v-if="[null,''].includes(selectedSubject)">
                                                            <b-button disabled block class="font-thai mt-2 font-weight-bold" variant="success">ดำเนินการส่งอีเมลล์ตาม List ({{ selectedIntable.length }}) ที่เลือก</b-button>
                                                        </div>
                                                        <div v-else>
                                                            <b-button v-if="loadsend" block class="font-thai" variant="primary" disabled>
                                                                <b-spinner small class="mr-2"></b-spinner>
                                                                <strong class="text-white">กำลังดำเนินการส่งเมลล์ ...</strong>
                                                            </b-button>
                                                            <b-button v-else @click="sendingMail" block class="font-thai mt-2 font-weight-bold" variant="success">ดำเนินการส่งอีเมลล์ตาม List ( {{ selectedIntable.length }} ) ที่เลือก</b-button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!--  
                                                    :select-mode="selectMode"
                                                    ref="selectableTable"
                                                    selectable
                                                    @row-selected="onRowSelected"
                                                -->
                                                <b-table 
                                                    class="mt-3 mb-3" 
                                                    responsive="sm" 
                                                    small 
                                                    striped 
                                                    hover 
                                                    :items="arrayGroupSend" 
                                                    :fields="fieldsMail"
                                                    show-empty
                                                    head-variant="dark"
                                                    bordered
                                                    sticky-header="80vh"
                                                    :busy="isLoadData"
                                                >
                                                    <template v-slot:table-busy>
                                                        <div class="thai-font text-center my-2">
                                                            <b-spinner class="align-middle"></b-spinner>
                                                            Load data list...
                                                        </div>
                                                    </template>
                                                    <template v-slot:cell(Choose)="row">
                                                        <div class="text-center">
                                                            <b-form-checkbox
                                                                :id="`checkbox-1-${row.item.student_id}`"
                                                                v-model="selectedIntable"
                                                                :name="`checkbox-1-${row.item.student_id}`"
                                                                :value="`${row.item.student_id}::${row.item.email_edu}::${row.item.email}`"
                                                                unchecked-value="not_accepted"
                                                            ></b-form-checkbox>
                                                        </div>
                                                    </template>
                                                    <template v-slot:cell(actionstatus)="row">
                                                        <p v-if="[true,'true','done'].includes(row.item.actionstatus)" class="mt-0 mb-0 text-success"><i class="fa fa-envelope-o" aria-hidden="true"></i></p>
                                                        <b-spinner v-if="row.item.actionstatus === row.item.student_id" small ></b-spinner>
                                                    </template>
                                                </b-table>

                                            </b-card-text>
                                        </b-card>
                                        <!-- {{ groupData }} <pre>{{ selectedIntable }}</pre> -->
                                    </div>
                                </div>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
        </div>
        <!-- save success -->
        <b-modal size="lg" ref="my-success-save" hide-footer hide-header-close>
            <b-card-text>
                <template v-slot:modal-title>
                    <h5 class="mt-1 mb-1">
                        <strong class="font-thai">บันทึกข้อมูล E-mail</strong>
                    </h5>
                </template>
                <p class="font-thai mt-3 mb-1">หัวข้อเมลล์ : {{ formDataMail.subject }}</p>
                <p class="font-thai mt-3 mb-1">ส่งจาก : {{ formDataMail.from_email }}</p>
                <p class="font-thai mt-3 mb-1">ตอบกลับ : {{ formDataMail.reply_to_email }}</p>
                <p class="font-thai mt-3 mb-3">(สำเนา) BCC E-mail : {{ formDataMail.bcc_email }}</p>
                <b-alert show variant="success-cus">
                    <span v-html="formDataMail.content"></span>
                </b-alert>
            </b-card-text>
            <hr>
            <b-button class="font-thai mt-2" @click="closeModal" variant="danger">
                <i class="fa fa-times mr-2" aria-hidden="true" />ปิด
            </b-button>
        </b-modal>
        <!-- test mail -->
        <b-modal ref="my-test-mail" hide-footer>
            <template v-slot:modal-title>
                <h5 class="mt-1 mb-1">
                    <strong class="font-thai text-danger">*** ทดสอบส่งเมลล์เพื่อดูตัวอย่าง ***</strong>
                </h5>
            </template>
            <b-card-text class="mb-3">
                <p class="font-thai mt-1 mb-0">ระบุอีเมลล์เพื่อทำการทดสอบ</p>
                <small class="font-thai mt-1 mb-3 text-muted">*** กด Enter 1 ครั้ง / การพิมพ์ ***</small>
                <input-tag class="mt-3 font-thai" v-model="inputTestmail"></input-tag>
                <div class="mt-3" v-if="loadTest">
                    <b-spinner small type="grow"></b-spinner><span class="ml-1 font-thai font-1x">กำลังดำเนินการส่งเมลล์</span>
                </div>
                <div v-else>
                    <div class="mt-3 text-right">
                        <b-button :disabled="inputTestmail.length == 0" size="sm" class="mr-3 font-thai font-1x mt-0 text-dark" @click="sendTest" variant="warning">
                            ส่งของความทดสอบ
                        </b-button>
                        <b-button size="sm" class="font-thai mt-0 font-1x" @click="closeModalTest" variant="dark">
                            ปิด
                        </b-button>
                    </div>
                </div>
            </b-card-text>
        </b-modal>
    </div>
</template>

<script>
    import readXlsxFile from "read-excel-file";
    const dataMailcontent = {
        from_email:'MUIC Announcement <ic-announcement@muic.io>',
        reply_to_email:'',
        bcc_email: [],
        subject:'',
        content:null,
    }
    import YimoVueEditor from 'yimo-vue-editor'
    export default {
        components: {
            YimoVueEditor
        },
        computed:{
            isBtnValid(){
                return this.selectedStdYear.length != 0 && this.selectedSubject !== '' ? true : false
            },
            editor() {
                return this.$refs.myQuillEditor.quill
            },
            isFormMail(){
                // this.formDataMail.bcc_email != 0 && 
                return this.formDataMail.from_email !== '' && this.formDataMail.reply_to_email !== '' && this.formDataMail.subject !== ''  && this.formDataMail.content !== '' ? true : false
            }
        },
        data(){
            return{
                success:false,
                loadsend:false,
                idStudent:null,
                arrResault:[],
                stdResault:0,
                errorMail:[],
                valueSend:0,
                uploadError:'',
                inputFile:null,
                file1: [],
                editorConfig: {
                    printLog: false,
                    menus: [
                        'bold',
                        'underline',
                        'italic',
                        'strikethrough',
                        'eraser',
                        'forecolor',
                        'bgcolor',
                        '|',
                        'quote',
                        'fontfamily',
                        'fontsize',
                        // 'head',
                        'unorderlist',
                        'orderlist',
                        'alignleft',
                        'aligncenter',
                        'alignright',
                        '|',
                        'link',
                        'unlink',
                        'table',
                        '|',
                        'img',
                        // 'video',
                        'insertcode',
                        '|',
                        'undo',
                        'redo',
                        'fullscreen',
                        '|',
                        'source',
                    ],
                    useLang:'en'
                },
                formDataMail: Object.assign({}, dataMailcontent),
                // send form
                selectedSubject:null,
                selectedStdYear:[],
                optionsSubject:[],
                optionsStdYear:[],
                dataResault:[],
                sendYear:'',
                loading_2 : false,
                loadTest:false,
                inputTestmail:[],
                itemsmsgHistory: [],
                isBusymsg: false,
                valEdit:'',
                viewIdItem:'',
                viewCase:'',
                // 
                groupData: [],
                selectedStdYearRadio: '',
                minInput: '',
                maxInput: '',
                checPressBtn: '1',
                arrayGroupSend: [],
                fieldsMail: [
                    { 
                        key: 'Choose',
                        label: '',
                        class: 'font-weight-bold text-center w-5', 
                        thStyle: 
                        { 
                            fontFamily: 'Kanit',
                            width:'5%',
                        }
                    },
                    {
                        key: 'actionstatus',
                        label: "สถานะการส่ง",
                        sortable: false,
                        class: 'text-center font-xxx w-5', 
                        thStyle: 
                        { 
                            fontSize: '12px',
                            fontFamily: 'Kanit',
                            width:'15%',
                        }
                    },
                    {
                        key: 'student_id',
                        sortable: false,
                        label: "ID",
                        class: 'text-center', 
                        thStyle: 
                        { 
                            fontFamily: 'Kanit',
                        } 
                    },
                    {
                        key: 'english_first_name',
                        sortable: false,
                        label: "Firstname",
                        class: 'text-left', 
                        thStyle: 
                        { 
                            fontFamily: 'Kanit',
                        }
                    },
                    {
                        key: 'english_last_name',
                        sortable: false,
                        label: "Lastname",
                        class: 'text-left', 
                        thStyle: 
                        { 
                            fontFamily: 'Kanit',
                        }
                    },
                    {
                        key: 'main_curriculum_code',
                        label: "Major",
                        sortable: false,
                        class: 'text-center', 
                        thStyle: 
                        { 
                            fontFamily: 'Kanit',
                        }
                    },
                    {
                        key: 'email',
                        sortable: true,
                        label: "E-mail ( acth )",
                        class: 'text-left font-xxx', 
                        tdStyle:{
                            fontSize:'10px'
                        },
                        thStyle: 
                        { 
                            fontFamily: 'Kanit',
                        }
                    },
                    {
                        key: 'email_edu',
                        sortable: false,
                        label: "E-mail ( edu )",
                        class: 'text-left font-xxx', 
                        tdStyle:{
                            fontSize:'10px'
                        },
                        thStyle: 
                        { 
                            fontFamily: 'Kanit',
                        }
                    },
                    
                ],
                selectedCaseSend:['edu','acth'],
                isLoadData: false,
                // table select
                selectMode: 'single',
                selectedIntable: [],
                // file upload
                file: null,
            }
        },
        mounted(){
            this.getSubjectmail()
            this.getStudentYear()
        },
        methods:{
            closeModalSuccess(){
                this.$refs['my-success'].hide() 
            },
            isEmpty(obj) {
                for(var key in obj) {
                    if(obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            },
            onRowSelected(items) {
                console.log(items)
                // console.log(items[0].student_id)
                // this.selectedIntable = items
            },
            getViewSend(val){
                this.file = null
                this.selectedIntable = []
                this.selectedStdYearRadio = ''
                this.minInput = ''
                this.maxInput = ''
                this.arrayGroupSend = []
                this.checPressBtn = val
            },
            selectAllRows() {
                this.$refs['selectableTable'].selectAllRows()
            },
            async getValData(event,val){
                // console.log(val)
                this.isLoadData = true
                this.arrayGroupSend = []
                this.selectedIntable = []
                this.groupData = []
                try {
                    const res = await this.$http.get(`/m2s/student/student_range/?min_student_id=${val}0000&max_student_id=${val}9999`)
                    if(res.status === 200){
                        for (let g = 0; g < res.data.length; g++) {
                            const element = res.data[g];
                            this.groupData.push(element.student_id)
                            this.selectedIntable.push(`${element.student_id}::${element.email_edu}::${element.email}`)
                        }
                        this.arrayGroupSend = res.data.map(item_table => {
                            return {
                                'Choose': true,
                                'student_id' : `${item_table.student_id}`,
                                'english_first_name' : item_table.english_first_name,
                                'english_last_name' : item_table.english_last_name,
                                'main_curriculum_code' : item_table.main_curriculum_code,
                                'email' : item_table.email,
                                'email_edu' : item_table.email_edu,
                                'actionstatus' :  '',
                            }
                        }) 
                        this.arrayGroupSend.sort(function(a, b) {
                            var nameA = a.student_id.toUpperCase();
                            var nameB = b.student_id.toUpperCase();
                            if (nameA < nameB) { return -1; }
                            if (nameA > nameB) { return 1; }
                            return 0;
                        });
                        this.isLoadData = false
                    }else{ 
                        throw { res };
                    }
                } catch (error) {
                    this.arrayGroupSend = []
                    this.isLoadData = false
                    console.log(error)
                }
            },
            async getValDataInput(){
                // console.log(val)
                this.isLoadData = true
                this.arrayGroupSend = []
                this.selectedIntable = []
                this.groupData = []
                try {
                    const res = await this.$http.get(`/m2s/student/student_range/?min_student_id=${this.minInput}&max_student_id=${this.maxInput}`)
                    if(res.status === 200){
                        for (let g = 0; g < res.data.length; g++) {
                            const element = res.data[g];
                            this.groupData.push(element.student_id)
                            this.selectedIntable.push(`${element.student_id}::${element.email_edu}::${element.email}`)
                        }
                        this.arrayGroupSend = res.data.map(item_table => {
                            return {
                                'Choose': true,
                                'student_id' : `${item_table.student_id}`,
                                'english_first_name' : item_table.english_first_name,
                                'english_last_name' : item_table.english_last_name,
                                'main_curriculum_code' : item_table.main_curriculum_code,
                                'email' : item_table.email,
                                'email_edu' : item_table.email_edu,
                                'actionstatus' :  '',
                            }
                        }) 
                        this.arrayGroupSend.sort(function(a, b) {
                            var nameA = a.student_id.toUpperCase();
                            var nameB = b.student_id.toUpperCase();
                            if (nameA < nameB) { return -1; }
                            if (nameA > nameB) { return 1; }
                            return 0;
                        });
                        this.isLoadData = false
                    }else{ 
                        throw { res };
                    }
                } catch (error) {
                    this.arrayGroupSend = []
                    console.log(error)
                    this.isLoadData = false
                }
            },
            clearFile(){
                this.arrayGroupSend = []
                this.selectedIntable = []
                this.groupData = []
                this.file = null
            },
            onFileChange(event) {
                this.arrayGroupSend = []
                this.selectedIntable = []
                this.groupData = []
                let indexID = 1;
                let xlsxfile = event.target.files ? event.target.files[0] : null;
                readXlsxFile(xlsxfile).then((rows) => {
                    for (let index = 0; index < rows.length; index++) {
                        if(index != 0){
                            // console.log(rows[index][0])
                            // console.log(rows[index][1])
                            // console.log(rows[index][2])
                            // console.log(rows[index][3])
                            // console.log(rows[index][4])
                            this.groupData.push(rows[index][0])
                            this.selectedIntable.push(`${rows[index][0]}::${rows[index][3]}::${rows[index][4]}`)
                            this.arrayGroupSend.push(
                                {
                                    'Choose': true,
                                    'student_id' : `${rows[index][0]}`,
                                    'english_first_name' : rows[index][1],
                                    'english_last_name' : rows[index][2],
                                    'main_curriculum_code' : rows[index][5],
                                    'email' : rows[index][4],
                                    'email_edu' : rows[index][3],
                                    'actionstatus' :  '',
                                }
                            )
                        }
                    }
                });
                // console.log(this.arrayGroupSend)
                // console.log(this.selectedIntable)
                // console.log(this.groupData)
            },
            async getSubjectmail(){
                this.isBusymsg = true
                this.itemsmsgHistory = []
                this.optionsSubject = []
                try {
                    const resYEAR = await this.$http.get(`/m2s/mailbox/`)
                    if(resYEAR.status === 200){
                        this.optionsSubject = resYEAR.data.map(item => {
                            return {
                                'value' : item.id,
                                'text': `${item.topic}`
                            }
                        })  
                        this.optionsSubject.sort((a, b) =>{ return b.value - a.value; });
                        this.optionsSubject.push({ value:null,text:'โปรดเลือก...',disabled: true })
                        // in table
                        this.itemsmsgHistory = resYEAR.data.map(item_table => {
                            return {
                                'id' : item_table.id,
                                'topic' : item_table.topic,
                                'from_email' : item_table.from_email,
                                'reply_to_email' : item_table.reply_to_email,
                                'bcc_email' : item_table.bcc_email,
                                'html_content' : item_table.html_content,
                                'creator' : item_table.creator,
                                'updated_at' : item_table.updated_at,
                                'created_at' : item_table.created_at,
                            }
                        }) 
                        this.itemsmsgHistory.sort((a, b) =>{ return b.id - a.id; });
                        this.isBusymsg = false
                    }
                } catch (error) { this.isBusymsg = false }
            },
            async getStudentYear(){
                this.optionsStdYear = []
                try {
                    const resYEAR = await this.$http.get(`/m2s/student/student_year/`)
                    if(resYEAR.status === 200){
                        this.optionsStdYear = resYEAR.data.map(item => {
                            return {
                                'value' : item.pre_fix_id,
                                'text': `${item.pre_fix_id}xxxx`,
                                'amount_users': item.amount_users
                            }
                        })
                    }
                } catch (error) {}
            },
            updateDataByrow(studentId,val){
                let arr = []
                const index = this.arrayGroupSend.findIndex(
                    (itemRe) => itemRe.student_id === studentId
                );
                let actionstatus = val
                this.arrayGroupSend[index] = {
                    ...this.arrayGroupSend[index],
                    actionstatus,
                }
                arr.push(this.arrayGroupSend[index])
                this.arrayGroupSend.splice(index, 1, arr[0]);
            },
            async sendingMail(){
                this.valueSend = 0
                this.stdResault = 0
                this.arrResault = []
                this.errorMail = []
                this.success = false
                this.loadsend = true
                this.dataResault = []
                this.sendYear = ''
                this.loading_2 = false
                // let concatData = []
                try {

                    
                    for (let std = 0; std < this.selectedIntable.length; std++) {
                        
                        let arraymailEdu = []
                        let arraymailActh = []
                        const dataSend = this.selectedIntable[std]

                        this.updateDataByrow(`${dataSend.split('::')[0]}`, `${dataSend.split('::')[0]}`)
                        // edu
                        arraymailEdu.push(dataSend.split('::')[1])
                        // ac th
                        arraymailActh.push(dataSend.split('::')[2])
                        // process
                        if(this.selectedCaseSend.length == 2){
                            let concatData = arraymailEdu.concat(arraymailActh)
                            // console.log(concatData)
                            for (let twoMail = 0; twoMail < concatData.length; twoMail++) {
                                const em1 = concatData[twoMail];
                                // console.log('xxx',twoMail,em1)
                                if(!['',null,'null','-'].includes(em1)){
                                    try {
                                        const sendmailDataA = new FormData()
                                        sendmailDataA.append('std_email', em1)
                                        const ressendA = await this.$http.post(`/m2s/mailbox/${this.selectedSubject}/sent_mail/`, sendmailDataA,{
                                            headers: { 'Content-Type': 'multipart/form-data' }
                                        })
                                        if([200,201].includes(ressendA.status)){
                                            // console.log(ressendA.data)
                                        }
                                    } catch (error) {
                                        console.log(error)
                                    }
                                }
                            }
                        }else{
                            if(this.selectedCaseSend.includes('edu')){
                                // console.log(dataSend.split('::')[1])
                                try {
                                    const sendmailDataA = new FormData()
                                    sendmailDataA.append('std_email', dataSend.split('::')[1])
                                    const ressendA = await this.$http.post(`/m2s/mailbox/${this.selectedSubject}/sent_mail/`, sendmailDataA,{
                                        headers: { 'Content-Type': 'multipart/form-data' }
                                    })
                                    if([200,201].includes(ressendA.status)){
                                        // console.log(ressendA.data)
                                    }
                                } catch (error) {
                                    console.log(error)
                                }
                            }else{
                                // console.log(dataSend.split('::')[2])
                                try {
                                    const sendmailDataA = new FormData()
                                    sendmailDataA.append('std_email', dataSend.split('::')[2])
                                    const ressendA = await this.$http.post(`/m2s/mailbox/${this.selectedSubject}/sent_mail/`, sendmailDataA,{
                                        headers: { 'Content-Type': 'multipart/form-data' }
                                    })
                                    if([200,201].includes(ressendA.status)){
                                        // console.log(ressendA.data)
                                    }
                                } catch (error) {
                                    console.log(error)
                                }
                            }
                        }
                        // อัพเดท row
                        this.updateDataByrow(`${dataSend.split('::')[0]}`, 'done')
                        this.loadsend = false
                    }
                } catch (error) {}
                this.selectedStdYear = []
                this.sendYear = ''
                this.stdResault = 0
                this.loading_2 = true
            },
            getFileExtension(filename)
            {
                if(filename){
                    return filename.type === 'image/jpg' || filename.type === 'image/jpeg' || filename.type === 'image/png' || filename.type === 'image/gif' || filename.type === 'application/pdf'
                }
            },
            UploadfileData(event){
                this.uploadError = ''
                if(this.getFileExtension(event.target.files[0])){
                    this.file1.push({
                        'name': event.target.files[0].name,
                        'file_data': event.target.files[0],
                        'size': ((event.target.files[0].size / (1024*1024)).toFixed(2))
                    })
                    this.$refs.fileInput.reset();
                }else{
                    this.uploadError = '.jpg , .jpeg , .png , .gif , .pdf only'
                }
            },
            async submitContent(){
                var dataBcc = ''
                try {
                    const sendFormData = new FormData()
                    sendFormData.append('topic', this.formDataMail.subject)
                    sendFormData.append('from_email', this.formDataMail.from_email)
                    sendFormData.append('reply_to_email', this.formDataMail.reply_to_email)
                    if(this.formDataMail.bcc_email.length != 0){
                        for (let bccInput = 0; bccInput < this.formDataMail.bcc_email.length; bccInput++) {
                            if(bccInput == (this.formDataMail.bcc_email.length-1)){
                                dataBcc += `${this.formDataMail.bcc_email[bccInput]}`
                            }else{
                                dataBcc += `${this.formDataMail.bcc_email[bccInput]},`
                            }
                        }
                        sendFormData.append('bcc_email', dataBcc)
                    }else{
                        sendFormData.append('bcc_email', '')
                    }
                    sendFormData.append('html_content', this.formDataMail.content+'<div>###TRACK###<br></div>')
                    sendFormData.append('creator', this.$keycloak.userName)
                    const saveContentMail = await this.$http.post(`/m2s/mailbox/`, sendFormData,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(saveContentMail.status === 201){
                        this.$refs['my-success-save'].show() 
                    }
                } catch (error) {}
            },
            closeModal(){
                this.formDataMail = Object.assign({}, dataMailcontent)
                this.$refs['my-success-save'].hide()
            },
            // test send mail
            modalTest(){
                this.inputTestmail = []
                this.$refs['my-test-mail'].show() 
            },
            closeModalTest(){
                this.inputTestmail = []
                this.$refs['my-test-mail'].hide()
            },
            async sendTest(){
                this.loadTest = true
                for (let testSend = 0; testSend < this.inputTestmail.length; testSend++) {
                    try {
                        const sendmailDataTest = new FormData()
                        sendmailDataTest.append('std_email', this.inputTestmail[testSend])
                        const ressendTest = await this.$http.post(`/m2s/mailbox/${this.selectedSubject}/sent_test/`, sendmailDataTest,{
                            headers: { 'Content-Type': 'multipart/form-data' }
                        })
                        if(ressendTest.status === 201){ this.loadTest = false }
                    } catch (error) {}
                }
                this.loadTest = false
                this.closeModalTest()
            },
            // manage data
            async delmsg(idDel){
                try {
                    const res = await this.$http.delete(`/m2s/mailbox/${idDel}/`)
                    if(res.status === 204){
                        this.getSubjectmail()
                    }
                } catch (error) {}
            },
            formEdit(dataVal,IdEdit,CaseEdit){
                this.valEdit = dataVal
                this.viewIdItem = IdEdit
                this.viewCase = CaseEdit
            },
            cancelView(){
                this.valEdit = ''
                this.viewIdItem = ''
                this.viewCase = ''
            },
            cancelViewContent(){
                this.valEdit = ''
                this.viewIdItem = ''
                this.viewCase = ''
                this.getSubjectmail()
            },
            async saveEdit(IdSave,columUpdate){
                var arrEdit = []
                try {
                    const sendFormDataEdit = new FormData()
                    sendFormDataEdit.append( columUpdate , this.valEdit)
                    const response = await this.$http.patch(`/m2s/mailbox/${IdSave}/`,
                        sendFormDataEdit,
                        {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }
                    )
                    if(response.status === 200){
                        const index = this.itemsmsgHistory.findIndex(itemChange => itemChange.id === IdSave)
                        arrEdit.push(
                            {
                                'id' : response.data.id,
                                'topic' : response.data.topic,
                                'from_email' : response.data.from_email,
                                'reply_to_email' : response.data.reply_to_email,
                                'bcc_email' : response.data.bcc_email,
                                'html_content' : response.data.html_content,
                                'creator' : response.data.creator,
                                'updated_at' : response.data.updated_at,
                                'created_at' : response.data.created_at,
                            }
                        )
                        this.itemsmsgHistory.splice(index, 1, arrEdit[0])
                        if(columUpdate === 'html_content'){ this.cancelViewContent() }else{
                            this.cancelView()
                        }
                    }
                } catch (error) {}
            },
        }   
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Kanit:wght@500&family=Sarabun:wght@500&display=swap');
    .w-50{ width: 50%; }
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .text-pur{ color: rgb(109, 58, 156); font-weight: 600; }
    .font-thai{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .f-small-choice{ font-size: 0.75rem; }
    .font-toppic{ font-size: 1.2rem; }
    .font-1x{ font-size: 1rem; }
    .font-2x{ font-size: 1.2rem; }
    .font-xxx{ font-size: 14px; }
    .f-table-s{ 
        font-family: 'Rubik', sans-serif; 
        font-weight: 100;
        font-size: 0.95rem; 
    }
    .font-en-chk{ font-family: 'Rubik', sans-serif; font-weight: 300; }
    .height-alert{
        height: 200px;
        overflow-y: scroll;
    }
    .height-alert-error{
        height: 175px;
        overflow-y: scroll;
    }
    .alert-success-cus {
        background-color: #ddfae8;
        color: #000000;
    }
    .alert-danger-cus{
        background-color: #fcd6d9;
        color: #000000;
    }
    .alert-warning-cus {
        background-color: #fff2cc;
        color: #000000;
        border-radius: 10px;
    }
    .alert-dark-cus {
        background-color: #eae6d9;
        color: #000000;
        border-radius: 10px;
    }
</style>

<style>
    .readText-mail{ white-space: pre-line; }
</style>